// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2aQfq","clinicsSelect":"TableHeading_clinicsSelect__2jblR"};